<template>
  <van-popup
    position="bottom"
    v-model="popupVisible"
    @click-overlay="onCancel"
  >
    <van-picker
      show-toolbar
      :columns="columns"
      :title="title"
      @change="itemChange"
    >
      <template slot="default">
        <div style="height: 44px" class="default-topbar">
          <p @click="onCancel" style="color:rgba(153,153,153,1);margin-left: 15px">取消</p>
          <p class="title">{{title}}</p>
          <p @click="onConfirm" style="color: rgba(33,150,243,1);margin-right: 15px">确定</p>
        </div>
      </template>
    </van-picker>
  </van-popup>
</template>

<script>
import { Picker, Popup } from 'vant'
export default {
  props: {
    columns: {
      type: Array
    },
    visible: {
      type: Boolean
    },
    type: {
      type: String
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      popupVisible: false,
      value: ''
    }
  },
  watch: {
    visible () {
      this.popupVisible = this.visible
    }
  },
  mounted () {
    this.value = this.columns[0]
  },
  methods: {
    onConfirm (value) {
      if (this.type) {
        this.$emit('confirm', { value: this.value, type: this.type })
      } else {
        this.$emit('confirm', { value: this.value })
      }
    },
    onCancel () {
      this.$emit('cancel')
    },
    itemChange (_, value) {
      this.value = value
    }
  },
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup
  }
}
</script>

<style lang="less" scoped>
  .default-topbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background:rgba(238,238,238,1);
    font-size: 28px;
    .title {
      color: rgba(153,153,153,1);
    }
  }
  .van-picker__toolbar {
    &:after {
      border: none !important;
    }
  }
</style>
